<template>
  <section class="section_base page">
    <section-header
        :title="title"
        :description="description"
    >
      <template v-slot:right>
        <slot name="right"></slot>
      </template>
    </section-header>

    <table-default
      v-if="tableData.length"
      :table-data="tableData"
      :default-sort="defaultSort"
    >
      <slot></slot>
    </table-default>

    <p v-else class="section_base--empty" v-html="emptyMessage"></p>
  </section>
</template>

<script>
import TableDefault from "../table/TableDefault";
export default {
  name: "SectionTable",
  components: {TableDefault},
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    tableData: {
      type: Array,
      required: true,
    },
    defaultSort: {
      type: String,
    },
    detailed: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: 'There is no data to display'
    }
  }
}
</script>

<style lang="scss" scoped>
// See section.scss for styles
</style>
